import React from "react";
import PropTypes from "prop-types";
import chroma from "chroma-js";
import cname from "../../Style/style.module.scss";

/**
 * AbsorbanceTable
 *  - A wrapper to display absorbance values
 */
export function AbsorbanceTable(props) {
  const absorbanceData = props.data.sort((a, b) =>
    a.ph < b.ph ? 1 : b.ph < a.ph ? -1 : 0
  );

  const arrayObjects = [];

  for (const key in absorbanceData) {
    const mappedData = {
      ...absorbanceData[key],
    };
    arrayObjects.push(mappedData);
  }

  const items = arrayObjects.map((item) => (
    <tr
      key={item.ph}
      className={props.phSliderValue === item.ph ? cname.highlight : null}
      style={{
        backgroundColor: props.whiteBackground === true ? "#033e6c" : null,
      }}
    >
      <td>{item.ph.toFixed(1)}</td>
      <td>{item.abs.toFixed(2)}</td>
    </tr>
  ));

  const nmValue = arrayObjects[0].nm + " nm";
  const { r, g, b } = arrayObjects[0].color;

  const MIN_CONTRAST_RATIO = 4.5,
    WHITE = chroma("white"),
    BLACK = chroma("black");

  function getBGColor() {
    let bg = null,
      text = null;
    do {
      text = chroma([r, g, b]);
      const contrastWithWhite = chroma.contrast(text, WHITE),
        contrastWithBlack = chroma.contrast(text, BLACK);

      if (contrastWithBlack >= MIN_CONTRAST_RATIO) {
        bg = BLACK;
      } else if (contrastWithWhite >= MIN_CONTRAST_RATIO) {
        bg = WHITE;
      }
    } while (bg === null);
    return bg.hex();
  }

  return (
    <div className={cname.items}>
      <div
        className={cname.invertedp}
        style={{ backgroundColor: getBGColor() }}
      >
        <p style={{ color: `rgb(${r},${g},${b})` }}>{nmValue}</p>
      </div>
      <table className={cname.table}>
        <tbody>
          <tr>
            <th>pH</th>
            <th>Absorbance</th>
          </tr>
          {items}
        </tbody>
      </table>
    </div>
  );
}

AbsorbanceTable.propTypes = {
  /**
   * Toggle to display and hide Absorbance Table
   */
  toggle: PropTypes.bool,

  /**
   * Data to display AbsorbanceTable
   */
  // data: PropTypes.object,

  /**
   * To ightlight PH value in table
   */
  phSliderValue: PropTypes.number,
};
